import { render, staticRenderFns } from "./addPortMapping.vue?vue&type=template&id=5c3584fb&scoped=true&"
import script from "./addPortMapping.vue?vue&type=script&lang=js&"
export * from "./addPortMapping.vue?vue&type=script&lang=js&"
import style0 from "./addPortMapping.vue?vue&type=style&index=0&id=5c3584fb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3584fb",
  null
  
)

export default component.exports